/* eslint-disable prettier/prettier */
import React, { type ReactElement, useState } from 'react'
import {
  // Accordion,
  // AccordionItem,
  // AccordionButton,
  // AccordionPanel,
  // AccordionIcon,
  Box,
  Button,
  Card,
  CardBody,
  Flex,
  Heading,
  HStack,
  Image,
  Tag,
  TagLabel,
  Icon,
  Text,
  Link as ChakraLink,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Grid,
  GridItem,
  UnorderedList,
  ListItem,
  ButtonGroup
} from '@chakra-ui/react'

import LogoClip from '../../components/logoClip'
import SideNav from '../../components/SideNav'
import Footer from '../../components/Footer'
import Wrap from '../../components/Wrap'
import { activities as activitiesObject, type Activity } from '../../activities'
import { Info } from 'lucide-react'
import '@fontsource/kalam'
import NoteLink from '../../components/NoteLink'
import ReactPlayer from 'react-player/youtube'
import ReactPlayerFile from 'react-player/file'

const cardStyles = {
  bg: 'yellow.300',
  boxShadow: 'sm',
  transition: 'all 200ms ease',
  height: '100%',
  borderRadius: 0,
  '.bend': {
    position: 'absolute',
    bg: 'white',
    bottom: '0px',
    right: '0px',
    borderStyle: 'solid',
    h: 'auto',
    aspectRatio: '1/1',
    w: '5%',
    boxShadow: '0px 2px 0px 0px white, 2px 0px 0px 0px white',
    transition: 'all 0.5s',
    zIndex: 2,
    overflow: 'hidden',
    '&:after': {
      pointerEvents: 'none',
      color: 'yellow.100',
      background:
        'linear-gradient(135deg, currentcolor calc(50% - 1px), rgba(232,232,232,1) 50%, rgba(255,255,255,0) 50.2%, rgba(255,255,255,0) 100%)',
      content: '""',
      display: 'block',
      pos: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0
    },
    button: {
      pos: 'absolute',
      right: '20px',
      bottom: '20px'
    }
  },
  '&:hover': {
    transitionDelay: '.1s'
  },
  '&:hover .bend': {
    w: { base: '5%', md: '25%' }
  }
}

const Page: React.FC = () => {
  // const pageContext = usePageContext() as any
  // eslint-disable-next-line prettier/prettier
  const [selectedActivity, setSelectedActivity] = useState<string>('')

  const activities = activitiesObject

  return (
    <>
      <Wrap id="home" justifyContent="center" bottomHR={false}>
        <Flex
          id="blackjack-roulette"
          flexDir={{ base: 'column-reverse', lg: 'row-reverse' }}
          pt={{ base: '30px', xl: '120px' }}
          gap="20px"
          w="100%"
          maxW={{ base: '500px', lg: 'initial' }}
          justifyContent={{ base: 'center', lg: 'space-between' }}
          minH="calc(60vh - 60px)"
        >
          <Flex
            flexDir="column"
            justifyContent="center"
            flexGrow={1}
            flexShrink={0}
            w={{ base: '100%', lg: '66%' }}
            maxW="450px"
            pr="20px"
          >
            <Heading
              as="h2"
              textAlign={{ base: 'center', lg: 'left' }}
              size={{ base: '2xl', lg: '3xl' }}
            >
              <Image
                src="/assets/bjr-logo.png"
                alt="Blackjack Roulette"
                style={{
                  marginLeft: '-14px'
                }}
              />
            </Heading>
            <Heading
              as="h3"
              textAlign={{ base: 'center', lg: 'left' }}
              fontSize="1.5em"
              lineHeight="1.2"
              style={{
                textWrap: 'balance'
              }}
            >
              A Roguelike "Spin" on Two Casino Classics.
            </Heading>
            <Text
              fontSize="18px"
              textAlign={{ base: 'center', lg: 'left' }}
              style={{
                textWrap: 'balance'
              }}
            >
              Play blackjack against a roulette wheel of opponents. Collect
              power-up boules and purchase insurance policies to give you the
              edge against the dealer in this strategic and chaotic mash-up.
            </Text>
            <ButtonGroup justifyContent={{ base: 'center', lg: 'flex-start' }}>
              <NoteLink
                href="https://store.steampowered.com/app/3930450/Blackjack_Roulette/"
                fontSize="1.25em"
                fontWeight="bold"
              >
                Buy Now!
              </NoteLink>
            </ButtonGroup>
          </Flex>
          <Flex
            flexDir="column"
            justifyContent="center"
            flexGrow="1"
            maxW="900px"
            pos="relative"
          >
            <Box pos="relative">
              <Flex pos="relative" justifyContent="center">
                <Box
                  position="absolute"
                  top="-5%"
                  right="0"
                  left="0"
                  aspectRatio={16 / 9}
                  zIndex="-1"
                >
                  <Box
                    w={{ base: '50%', lg: '90%' }}
                    h={{ base: '50%', lg: '90%' }}
                    filter="blur(75px)"
                    maxH="500px"
                    borderRadius="50%"
                    mx="auto"
                    background="linear-gradient(135deg, #FAAB36 0%, #FAAB36 50%, #249EA0 50%, #249EA0 100%);"
                  />
                </Box>
                <Box
                  display={{
                    base: 'block',
                    md: 'block'
                  }}
                  pos="relative"
                  mx="auto"
                  as={ReactPlayer}
                  className="blur"
                  filter="url(#blur-and-scale)"
                  url="https://www.youtube.com/watch?v=N3wzXZdpxss&ab_channel=Reactvts"
                  width="100%"
                  minH={{
                    base: '40px',
                    lg: '240px'
                  }}
                  controls={true}
                  objectFit={'cover'}
                  muted={true}
                  playing={true}
                  loop={true}
                  zIndex={100}
                  mt="40px"
                  aspectRatio={16 / 9}
                  _hover={{
                    animation: 'none !important'
                  }}
                  sx={{
                    maxH: {
                      base: 'calc((100vw - 40px) * (9/16))'
                    },
                    animation: 'cardWiggleFlip 10s infinite normal forwards'
                  }}
                />
              </Flex>
            </Box>
          </Flex>
        </Flex>
      </Wrap>

      <Wrap
        id="about"
        bottomHR={false}
        bg="linear-gradient(180deg, #249ea017 0%, rgba(255,255,255,1) 10vh)"
        pt="120px"
      >
        <Flex
          flexDir="column"
          justifyContent="center"
          w={{ base: '90%', lg: '90%' }}
          maxW="750px"
          mx="auto"
        >
          <Heading>
            <Box
              as="span"
              backgroundClip="text"
              backgroundImage="linear-gradient(148deg, rgba(253, 89, 1, 1) 0%, rgba(247, 129, 4, 1) 15%, rgba(250, 171, 54, 1) 30%, rgba(36, 158, 160, 1) 70%, rgba(0, 128, 131, 1) 85%, rgba(0, 95, 96, 1) 100%)"
            >
              {' '}
              Hi, I&apos;m Seve – Web Engineer, Enjoyer of Games and Obsessive
              Problem Solver.{' '}
            </Box>
          </Heading>
          <Text variant="smaller">
            I love using Web Technologies, specificly React.js, to create
            interactive games and activities. I{"'"}m always looking for new
            ways to use technology to make things more fun and engaging, so I
            created Reactvts.com as a place to experiment with new ideas.
          </Text>
          <Heading textAlign="center" mt="20px" mb="0">
            <Box
              as="span"
              backgroundClip="text"
              backgroundImage="linear-gradient(148deg, rgba(253, 89, 1, 1) 0%, rgba(247, 129, 4, 1) 15%, rgba(250, 171, 54, 1) 30%, rgba(36, 158, 160, 1) 70%, rgba(0, 128, 131, 1) 85%, rgba(0, 95, 96, 1) 100%)"
            >
              It&apos;s <strong>REACT</strong> plus <strong>ACTIVITIES!</strong>
            </Box>
          </Heading>
          <Text fontSize="14px" textAlign="center" lineHeight="1" mb="40px">
            (minus a bunch of vowels… Look, branding is hard and domains are
            limited.)
          </Text>
          <Text variant="smaller">
            This will be my playground to test ideas and build prototypes. To
            toss spaghetti at the wall, and see what sticks. It&apos;s a chance
            for me to dive into new tech, step out of my coding comfort zone,
            and push my limits. Follow my progres on{' '}
            <NoteLink href="https://www.youtube.com/@reactvts">
              Youtube
            </NoteLink>{' '}
            and{' '}
            <NoteLink href="https://www.twitch.tv/reactvts">Twitch</NoteLink> –
            drop by and say hello!
          </Text>
          <Text variant="smaller">
            I&apos;m hustling to create more activities and refine the existing
            ones. A Warning: some of them might be a bit wonky and crash.
            Apologies in advance. But the more people enjoy a particular game or
            activity, the more I&apos;ll fine-tune it. (Keep in mind, this is a
            side hustle; I&apos;ve got a day job.)
          </Text>
          <Text variant="smaller">
            So if you&apos;re interested, you can stay connected on{' '}
            <NoteLink href="https://reactvts.bsky.social">Bluesky</NoteLink>,{' '}
            <NoteLink
              href="https://reactvts.bsky.social"
              style={{ textDecorationLine: 'line-through' }}
            >
              Twitter
            </NoteLink>
            ,{' '}
            <NoteLink href="https://www.youtube.com/@reactvts">
              Youtube
            </NoteLink>
            , <NoteLink href="https://www.twitch.tv/reactvts">Twitch</NoteLink>,{' '}
            <NoteLink href="https://discord.gg/z2uZC4mFed">Discord</NoteLink>{' '}
            and{' '}
            <NoteLink href="https://www.linkedin.com/company/reactvts">
              LinkedIn
            </NoteLink>
          </Text>
          <Text variant="smaller">-Seve</Text>
        </Flex>
      </Wrap>

      <Wrap
        id="activities"
        bg="linear-gradient(180deg, #F6E05E2b 0%, rgba(255,255,255,1) 10vh)"
        pt="120px"
        bottomHR={false}
      >
        <Box mx="auto">
          <Box maxWidth={{ base: '350px', md: '700px', xl: 'initial' }}>
            <Heading as="h3" textAlign="center" size="2xl">
              <Box
                as="span"
                backgroundClip="text"
                backgroundImage="linear-gradient(148deg, rgba(253, 89, 1, 1) 0%, rgba(247, 129, 4, 1) 15%, rgba(250, 171, 54, 1) 30%, rgba(36, 158, 160, 1) 70%, rgba(0, 128, 131, 1) 85%, rgba(0, 95, 96, 1) 100%)"
              >
                Activities & Prototypes
              </Box>
            </Heading>

            <Grid
              templateColumns={{
                base: '1fr',
                md: '1fr 1fr',
                xl: '1fr 1fr 1fr'
              }}
              gap="20px"
              mt="60px"
            >
              {Object.values(activities)
                .filter((activity) => {
                  return activity.active
                })
                .map((activity: Activity, index: number): ReactElement => {
                  return (
                    <GridItem key={index}>
                      <Card sx={cardStyles}>
                        <CardBody pos="relative" pb="90px">
                          <Heading variant="emoji" as="p" textAlign="center">
                            {activity.emojis}
                          </Heading>
                          <Heading as="h3" size="lg" mb="0px">
                            {activity.name}
                          </Heading>

                          <Text
                            fontSize="14px"
                            fontWeight="900"
                            mt="0"
                            mb="10px"
                          >
                            {activity.recommendedSize}{' '}
                            {activity.recommendedSize === '1'
                              ? 'PERSON'
                              : 'PEOPLE'}
                          </Text>
                          <Text as="h4" fontSize="14px" mt="10px" mb="15px">
                            {activity.description[0]}
                          </Text>
                          <HStack wrap="wrap" spacing={2}>
                            {activity.categories.map((category, index) => (
                              <Tag
                                size="md"
                                key={`cat-${index}`}
                                colorScheme="blackAlpha"
                              >
                                <TagLabel>{category}</TagLabel>
                              </Tag>
                            ))}
                          </HStack>

                          {/* <Text variant="smaller">{activity.description}</Text> */}
                          <ButtonGroup pos="absolute" left="20px" bottom="20px">
                            <Button
                              as="a"
                              href={`${activity.slug.includes('http') ? activity.slug : `/${activity.slug}`}`}
                              variant="outlineNegative"
                            >
                              Start Activity
                            </Button>
                            <Button
                              variant="outlineNegative"
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                setSelectedActivity(activity.key)
                              }}
                            >
                              <Icon
                                as={Info}
                                color="currentcolor"
                                boxSize="1.2em"
                                mb="0em"
                                mr="0.5em"
                              />{' '}
                              About
                            </Button>
                          </ButtonGroup>
                        </CardBody>
                        <Box className="bend" />
                      </Card>
                    </GridItem>
                  )
                })}
            </Grid>
          </Box>
        </Box>
      </Wrap>

      <Wrap
        bottomHR={false}
        bg="linear-gradient(180deg, #249ea017 0%, rgba(255,255,255,1) 10vh)"
        pt="120px"
      >
        <Flex
          flexDir="column"
          justifyContent="center"
          w={{ base: '90%', lg: '90%' }}
          maxW="750px"
          mx="auto"
        >
          <Heading as="h3" textAlign="center" mb="1em">
            <Box
              as="span"
              backgroundClip="text"
              backgroundImage="linear-gradient(148deg, rgba(253, 89, 1, 1) 0%, rgba(247, 129, 4, 1) 15%, rgba(250, 171, 54, 1) 30%, rgba(36, 158, 160, 1) 70%, rgba(0, 128, 131, 1) 85%, rgba(0, 95, 96, 1) 100%)"
            >
              Sponsors
            </Box>
          </Heading>
          <Text textAlign="center" variant="smaller">
            <ChakraLink
              display="block"
              textDecoration="underline dotted"
              href="https://ko-fi.com/U7U5RO3O9"
              target="_blank"
              mt="10px"
            >
              <Image
                display="inline-block"
                src="https://storage.ko-fi.com/cdn/brandasset/kofi_bg_tag_dark.png"
                alt="Kofi"
                height="100px"
              />
            </ChakraLink>
          </Text>
        </Flex>
      </Wrap>
      <Footer />
      <Modal
        size="3xl"
        isOpen={selectedActivity !== ''}
        onClose={() => {
          setSelectedActivity('')
        }}
      >
        <ModalOverlay />
        {selectedActivity !== '' && (
          <ModalContent>
            <ModalHeader>
              <Heading size="lg" mb="0">
                {activities[selectedActivity]?.name} V
                {activities[selectedActivity]?.version}
              </Heading>
              <Text fontSize="14px" fontWeight="900" mt="0" mb="0px">
                {activities[selectedActivity]?.recommendedSize} PEOPLE
              </Text>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Heading size="md" mb="20px">
                {typeof activities[selectedActivity ?? 0].description ===
                'string'
                  ? activities[selectedActivity ?? 0].description
                  : [...activities[selectedActivity ?? 0].description].map(
                      (entry: string, index: number) => {
                        return (
                          <React.Fragment key={index}>
                            {entry}
                            <br />
                            <br />
                          </React.Fragment>
                        )
                      }
                    )}
              </Heading>

              <Heading size="md">Patch Notes</Heading>
              {activities[selectedActivity ?? 0].patchNotes.map(
                (entry, index) => {
                  return (
                    <Text
                      variant="smaller"
                      fontSize="14px"
                      key={index}
                      pb="10px"
                    >
                      <strong>{entry.date}</strong>
                      <br />
                      {entry.notes}
                    </Text>
                  )
                }
              )}
              <br />
              {activities[selectedActivity ?? 0].roadmap.length > 0 && (
                <>
                  <Heading size="md">Roadmap</Heading>
                  <UnorderedList>
                    {activities[selectedActivity ?? 0].roadmap.map(
                      (entry, index) => {
                        return (
                          <Text
                            as={ListItem}
                            variant="smaller"
                            fontSize="14px"
                            key={index}
                          >
                            {entry}
                          </Text>
                        )
                      }
                    )}
                  </UnorderedList>
                </>
              )}
            </ModalBody>

            <ModalFooter>
              <Button
                variant="outlineNegative"
                mr={3}
                onClick={() => {
                  setSelectedActivity('')
                }}
              >
                Close
              </Button>
            </ModalFooter>
          </ModalContent>
        )}
      </Modal>
      <SideNav />
    </>
  )
}

export { Page }
